import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_lamp",
  "use": "icon-project_lamp-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_lamp\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\" stroke-linecap=\"round\"><path d=\"M18.587 19.963A10.044 10.044 0 0024 11.04C24 5.495 19.523 1 14 1S4 5.495 4 11.04c0 3.913 2.23 7.304 5.484 8.96\" /><path stroke-linejoin=\"round\" d=\"M10 20v3h8l-.024-3\" /><path d=\"M9.455 26.5h9.09\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol